import * as dto from '@epicuro-next/data/baskets-dto';
import { OrderType } from 'graphql-api/baskets-api-interfaces';

export function getDiscountsType(items: dto.Item[]) {
  const filteredItems = items.filter((item) => item.prices?.discount);
  if (filteredItems.length > 0) {
    return filteredItems.every(
      (item) => item.orderType === dto.OrderType.Future,
    )
      ? OrderType.Future
      : OrderType.Now;
  }
  return undefined;
}
